import "./App.css";
import { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Sidebar from "./Sidebar/sidebar";
import Notification from "./Notification/Notification";

// PAGES
import ModernGlassDashboard from "./pages/Dashboard";
import PurchaseRequisitionUI from "./PurchaseRequest/CreatePurchaseRequisitionUI";
import ReferenceCards from "./Maintenance/ReferenceCards";
import DepartmentPage from "./Maintenance/Departments";
import CompanyPage from "./Maintenance/Companies";
import LocationPage from "./Maintenance/Locations";
import VendorPage from "./Maintenance/Vendors";
import ShippingInformation from "./Maintenance/ShippingInformation";
import ExpenseTypePage from "./Maintenance/ExpenseType";
import UserLevelPage from "./Maintenance/UserLevel";
import UserManagement from "./Maintenance/Users";
import PaymentMethodsPage from "./Maintenance/PaymentMethod";
import MyRequestsPage from "./PurchaseRequest/MyRequestsPage";
import PurchaseOrder from "./PurchaseOrder/PurchaseOrder";
import PurchaseOrdersPage from "./PurchaseOrder/PurchaseOrdersPage";
import POReceiving from "./PurchaseOrder/POReceiving";
import POInvoiceTransmittal from "./PurchaseOrder/POInvoiceTransmittal";
import PRApproval from "./Approvals/PRApproval";
import POApproval from "./Approvals/POApproval";
import PRApprovalHistory from "./ApprovalHistory/PRApprovalHistory";
import POApprovalHistory from "./ApprovalHistory/POApprovalHistory";
import PO_Reports from "./Reports/PO_Reports";
import PR_Reports from "./Reports/PR_Reports";
import PositionLevelAccess from "./Access_sidebar/PositionLevelAccess";
import MyProfile from "./Account/Myprofile";
import Settingss from "./Setting/Settings";
import LicenseSelectionPage from "./Maintenance/License";
import ApproverPositionManagement from "./Maintenance/ApproverPositionManagement";
import UnderMaintenancePage from "./pages/UnderMaintenancePage";
import ChangePasswordPage from "./Setting/Changepassword";
import Website_status_maintenance from "./Maintenance/Website_status_maintenance";
import InventoryDestinationManager from "./Inventory/InventoryDestinationManager";
import InventoryDistribution from "./Inventory/InventoryDistribution";
import WebsiteInfoPage from "./Maintenance/WebsiteInfoPage";
import ItemMaintenance from "./Maintenance/Item";
import SecondPR_Approval from "./2ndApproval/PR_Approval";
import GoodsReceipt from "./GR/GoodsReceipt";
import WarehousePage from "./Maintenance/Warehouse";
import GRViewList from "./GR/GRViewList";
import InventoryList from "./InventoryStock/InventoryList";
import StockAdjustmentList from "./InventoryStock/StockAdjustmentList";
import StockAdjustmentForm from "./InventoryStock/Stockadjustmentform";
import MaterialRequestForm from "./Materialrequestform/Materialrequestform";
import MaterialRequestList from "./Materialrequestform/MaterialRequestList";
import MaterialRequestApproval from "./Approvals/Materialrequestapproval";
import PrPoTagsItem from "./PurchaseRequest/PrPoTagsItem";
import LicenseManagement from "./Maintenance/LicenseManagement";
import RmReports from "./Reports/RMReports";
import FuelRequisitionList from "./FuelRequisitionForm/FuelRequisitionList";
import FuelRequisitionForm from "./FuelRequisitionForm/FuelRequisitionForm";
import ReturnRequestList from "./Materialrequestform/Returnrequestlist";
import FuelRequisitionApproval from "./FuelRequisitionForm/FuelRequisitionApproval";
import ShipToShipRequestViewer from "./Materialrequestform/Shiptoshiprequestviewer";
import MRFolderByDate from "./Materialrequestform/MRFolderByDate";
import Logs from "./pages/Logs";
import NotificationConfig from "./Notification/Notificationconfig";
import PRPOManual from "./pages/PRPOManual"
import NotificationSettings from "./Notification/NotificationSettings";
// LOGIN
import Requestor from "./Maintenance/Requestor";
import AdminLoginPage from "./Login/AdminLoginPage";
import PRNotification from "./PurchaseRequest/PRNotification";
import MRNotification from "./Materialrequestform/MRNotification";

import PONotification from "./PurchaseOrder/Ponotification";
// API
import API_BASE_URL from "./config";


import CombinedDashboard from "./pages/Combineddashboard";
// ======================
// PROTECTED DASHBOARD
// ======================
function DashboardRoute() {
  return <MainApp />;
}

// ======================
// MAIN APP
// ======================
function MainApp() {
  const [isLoggedIn, setIsLoggedIn] = useState(
    sessionStorage.getItem("isLoggedIn") === "true"
  );

  const [currentPage, setCurrentPage] = useState(
    localStorage.getItem("currentPage") || "dashboard"
  );

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [websiteStatus, setWebsiteStatus] = useState(null);
  const [checkingStatus, setCheckingStatus] = useState(true);

  // ✅ Detect mobile — sidebar should overlay on mobile, not push content
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const userPosition = sessionStorage.getItem("positionId");

  // SAVE CURRENT PAGE
  useEffect(() => {
    localStorage.setItem("currentPage", currentPage);
  }, [currentPage]);

  // WEBSITE STATUS
  useEffect(() => {
    const fetchWebsiteStatus = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}api/Website/1`);
        if (res.ok) setWebsiteStatus(await res.json());
      } catch (err) {
        console.error(err);
      } finally {
        setCheckingStatus(false);
      }
    };

    fetchWebsiteStatus();
    const interval = setInterval(fetchWebsiteStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  const handleLoginSuccess = () => {
    sessionStorage.setItem("isLoggedIn", "true");
    setIsLoggedIn(true);
  };

  if (!isLoggedIn) {
    return <AdminLoginPage onLogin={handleLoginSuccess} />;
  }

  const isSystemAdmin = userPosition === "SYSTEM ADMIN";

  if (
    !checkingStatus &&
    websiteStatus?.website_Status === false &&
    !isSystemAdmin &&
    currentPage !== "Website"
  ) {
    return <UnderMaintenancePage />;
  }

  // ✅ KEY FIX: On mobile, sidebar overlays (no marginLeft)
  // On desktop, sidebar is fixed 256px so main needs marginLeft
  const getMainContentStyles = () => {
    const sidebarPosition = localStorage.getItem("sidebarPosition") || "left";
    const isHorizontal = sidebarPosition === "top" || sidebarPosition === "bottom";

    // Mobile: always full width, no margin (sidebar overlays)
    if (isMobile) {
      return {
        flex: 1,
        width: "100%",
        minHeight: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
        // Add top padding if sidebar is on top (horizontal mobile)
        paddingTop: sidebarPosition === "top" ? "64px" : "0",
        paddingBottom: sidebarPosition === "bottom" ? "64px" : "0",
        transition: "all 0.3s ease",
      };
    }

    // Desktop horizontal (top/bottom)
    if (isHorizontal) {
      return {
        flex: 1,
        minHeight: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
        paddingTop: sidebarPosition === "top" ? "64px" : "0",
        paddingBottom: sidebarPosition === "bottom" ? "64px" : "0",
        transition: "all 0.3s ease",
      };
    }

    // Desktop vertical — only add margin if sidebar is NOT collapsed
    if (sidebarCollapsed) {
      return {
        flex: 1,
        minHeight: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
        transition: "all 0.3s ease",
      };
    }

    return {
      flex: 1,
      minHeight: "100vh",
      overflowY: "auto",
      overflowX: "hidden",
      marginLeft: sidebarPosition === "left" ? "256px" : "0",
      marginRight: sidebarPosition === "right" ? "256px" : "0",
      transition: "all 0.3s ease",
    };
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    sessionStorage.removeItem("isLoggedIn");
    localStorage.removeItem("currentPage");
  };

  const renderPage = () => {
    switch (currentPage) {
      case "dashboard": return <ModernGlassDashboard />;
      case "CreatePO": return <PurchaseRequisitionUI setCurrentPage={setCurrentPage} />;
      case "referencess": return <ReferenceCards setCurrentPage={setCurrentPage} />;
      case "department": return <DepartmentPage setCurrentPage={setCurrentPage} />;
      case "companyPage": return <CompanyPage setCurrentPage={setCurrentPage} />;
      case "locationPage": return <LocationPage setCurrentPage={setCurrentPage} />;
      case "vendorPage": return <VendorPage setCurrentPage={setCurrentPage} />;
      case "shippingInformation": return <ShippingInformation setCurrentPage={setCurrentPage} />;
      case "expenseTypePage": return <ExpenseTypePage setCurrentPage={setCurrentPage} />;
      case "userLevelPage": return <UserLevelPage setCurrentPage={setCurrentPage} />;
      case "UserManagement": return <UserManagement setCurrentPage={setCurrentPage} />;
      case "PaymentMethodsPage": return <PaymentMethodsPage setCurrentPage={setCurrentPage} />;
      case "PurchaseRequests": return <MyRequestsPage setCurrentPage={setCurrentPage} />;
      case "PurchaseOrder": return <PurchaseOrder setCurrentPage={setCurrentPage} />;
      case "PurchaseOrdersPage": return <PurchaseOrdersPage setCurrentPage={setCurrentPage} />;
      case "POReceiving": return <POReceiving setCurrentPage={setCurrentPage} />;
      case "POInvoiceTransmittal": return <POInvoiceTransmittal setCurrentPage={setCurrentPage} />;
      case "PRApproval": return <PRApproval setCurrentPage={setCurrentPage} />;
      case "POApproval": return <POApproval setCurrentPage={setCurrentPage} />;
      case "PRApprovalHistory": return <PRApprovalHistory setCurrentPage={setCurrentPage} />;
      case "POApprovalHistory": return <POApprovalHistory setCurrentPage={setCurrentPage} />;
      case "PO_Reports": return <PO_Reports setCurrentPage={setCurrentPage} />;
      case "PR_Reports": return <PR_Reports setCurrentPage={setCurrentPage} />;
      case "PositionLevelAccess": return <PositionLevelAccess setCurrentPage={setCurrentPage} />;
      case "MyProfile": return <MyProfile setCurrentPage={setCurrentPage} />;
      case "Settingss": return <Settingss setCurrentPage={setCurrentPage} />;
      case "LicenseSelectionPage": return <LicenseSelectionPage setCurrentPage={setCurrentPage} />;
      case "ApproverPositionManagement": return <ApproverPositionManagement setCurrentPage={setCurrentPage} />;
      case "ChangePassword": return <ChangePasswordPage setCurrentPage={setCurrentPage} />;
      case "Website": return <Website_status_maintenance setCurrentPage={setCurrentPage} />;
      case "InventoryDestinationManager": return <InventoryDestinationManager setCurrentPage={setCurrentPage} />;
      case "InventoryDistribution": return <InventoryDistribution setCurrentPage={setCurrentPage} />;
      case "WebsiteInformation": return <WebsiteInfoPage setCurrentPage={setCurrentPage} />;
      case "ItemMaintenance": return <ItemMaintenance setCurrentPage={setCurrentPage} />;
      case "SecondPR_Approval": return <SecondPR_Approval setCurrentPage={setCurrentPage} />;
      case "GoodsReceipt": return <GoodsReceipt setCurrentPage={setCurrentPage} />;
      case "Requestor": return <Requestor setCurrentPage={setCurrentPage} />;
      case "WarehousePage": return <WarehousePage setCurrentPage={setCurrentPage} />;
      case "GRViewList": return <GRViewList setCurrentPage={setCurrentPage} />;
      case "InventoryList": return <InventoryList setCurrentPage={setCurrentPage} />;
      case "StockAdjustmentList": return <StockAdjustmentList setCurrentPage={setCurrentPage} />;
      case "StockAdjustmentForm": return <StockAdjustmentForm setCurrentPage={setCurrentPage} />;
      case "MaterialRequestForm": return <MaterialRequestForm setCurrentPage={setCurrentPage} />;
      case "MaterialRequestList": return <MaterialRequestList setCurrentPage={setCurrentPage} />;
      case "ReturnRequestList": return <ReturnRequestList setCurrentPage={setCurrentPage} />;
      case "MaterialRequestApproval": return <MaterialRequestApproval setCurrentPage={setCurrentPage} />;
      case "LicenseManagement": return <LicenseManagement setCurrentPage={setCurrentPage} />;
      case "RmReports": return <RmReports setCurrentPage={setCurrentPage} />;
      case "FuelRequestForm": return <FuelRequisitionForm setCurrentPage={setCurrentPage} />;
      case "FuelRequisitionList": return <FuelRequisitionList setCurrentPage={setCurrentPage} />;
      case "FuelRequisitionApproval": return <FuelRequisitionApproval setCurrentPage={setCurrentPage} />;
      case "ShipToShipRequestViewer": return <ShipToShipRequestViewer setCurrentPage={setCurrentPage} />;
      case "MRFolderByDate": return <MRFolderByDate setCurrentPage={setCurrentPage} />;
      case "Notification": return <NotificationConfig setCurrentPage={setCurrentPage} />;
      case "PRPOManual": return <PRPOManual setCurrentPage={setCurrentPage} />;
      case "NotificationSettings": return <NotificationSettings setCurrentPage={setCurrentPage} />;
      case "CombinedDashboard": return <CombinedDashboard setCurrentPage={setCurrentPage} />;



      case "Logs": return <Logs setCurrentPage={setCurrentPage} />;
      default: return <ModernGlassDashboard />;
    }
  };

  return (
    // ✅ Remove overflow-hidden on mobile so content scrolls properly
    <div className={`App ${isMobile ? "flex flex-col" : "flex"} min-h-screen`}>
      <Sidebar
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
        onLogout={handleLogout}
      />
      {/* ✅ Main content — takes full width on mobile */}
      <main style={getMainContentStyles()}>
        {renderPage()}
      </main>
      <Notification />
      <MRNotification />   {/* ← DAGDAG ITO */}
      <PRNotification />
      <PONotification />


    </div>
  );
}

// ======================
// ROUTES
// ======================
export function App() {
  return (
    <Routes>
      <Route path="/" element={<DashboardRoute />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}